<template>
   <div ref="scrollRef" class="inf-scroll-container">
      <slot></slot>
      <div class="info-container">
        <div v-if="isLoading || hideLoading" class="loader"></div>
      </div>
      <div v-if="isEndReached && !hideEndMessage" class="info-container">
        <div class="label-no-more">{{ endMessage }}</div>
      </div>
   </div>
</template>

<script>
export default {
  name: 'VueInfiniteScroll',
  props: {
    scrollElementId: {
      type: String,
    },
    hideLoading: {
      type: Boolean
    },
    isLoading: {
      type: Boolean
    },
    isEndReached: {
      type: Boolean
    },
    hideEndMessage: {
      type: Boolean
    },
    endMessage: {
      type: String,
      default: 'No more content'
    }
    
  },
  data: () => ({
    disableScroll: false,
  }),
  mounted(){
    const elId = this.$store.state.isMobile ? 'content' : 'scroll-content'
    document.getElementById(elId)?.addEventListener("scroll", this.handleScroll)
    this.handleScroll()
  },
  unmounted() {
    const elId = this.$store.state.isMobile ? 'content' : 'scroll-content'
    document.getElementById(elId)?.removeEventListener("scroll", this.handleScroll)
  },
  methods: {

    handleScroll() {
      if (!this.isLoading && !this.isEndReached){
        const element = this.$refs.scrollRef
        const scrollable = document.getElementById('scroll-content')
        if (element?.getBoundingClientRect().bottom < scrollable.clientHeight) {
          // loadMorePosts()
          this.$emit('loadMore')
        }
      }
    }

  }
}
</script>

<style scoped lang="scss">
  .inf-scroll-container {
    .label-no-more {
      color: var(--geoff-txt-secondary);
    }
    .info-container {
      margin: 0.75rem;
      display: flex;
      justify-content: center;
    }
  }
  
  /* HTML: <div class="loader"></div> */
  .loader {
    width: 15px;
    aspect-ratio: 1;
    border-radius: 50%;
    animation: l5 1s infinite linear alternate;
  }
  @keyframes l5 {
      0%  {box-shadow: 20px 0 var(--geoff-inf-loader-01), -20px 0 var(--geoff-inf-loader-02);background: var(--geoff-inf-loader-01) }
      33% {box-shadow: 20px 0 var(--geoff-inf-loader-01), -20px 0 var(--geoff-inf-loader-02);background: var(--geoff-inf-loader-02)}
      66% {box-shadow: 20px 0 var(--geoff-inf-loader-02),-20px 0 var(--geoff-inf-loader-01); background: var(--geoff-inf-loader-02)}
      100%{box-shadow: 20px 0 var(--geoff-inf-loader-02),-20px 0 var(--geoff-inf-loader-01); background: var(--geoff-inf-loader-01) }
  }
</style>